import React from "react";
import { Form } from "react-bootstrap";

export const cardStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #e3ecf3",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(29, 95, 145, 0.08)",
};

export const labelStyle = {
  fontSize: "0.8rem",
  fontWeight: "600",
  color: "#344a5e",
  marginBottom: "0.3rem",
};

export const iconChipStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "34px",
  height: "34px",
  borderRadius: "10px",
  border: "1px solid #b7dbf7",
  background:
    "linear-gradient(to bottom right, #ffffff 0%, #d9ebf9 45%, #c2e5fc 100%)",
  color: "#1d5f91",
  flexShrink: 0,
};

export const Req = () => <span style={{ color: "#dc3545" }}> *</span>;

export const SectionCard = ({ icon, title, subtitle, children }) => (
  <div style={{ ...cardStyle, padding: "1rem 1.1rem", marginBottom: "0.9rem" }}>
    <div
      className="d-flex align-items-center"
      style={{
        gap: "0.65rem",
        paddingBottom: "0.7rem",
        marginBottom: "0.9rem",
        borderBottom: "1px solid #eef4f9",
      }}
    >
      <span style={iconChipStyle}>{icon}</span>
      <div>
        <div
          style={{ fontWeight: "700", color: "#1d5f91", fontSize: "0.95rem" }}
        >
          {title}
        </div>
        {subtitle && (
          <small className="text-muted" style={{ fontSize: "0.75rem" }}>
            {subtitle}
          </small>
        )}
      </div>
    </div>
    {children}
  </div>
);

export const YesNoRadios = ({ name, value, onChange }) => (
  <div
    className="horizontal-radio-group"
    style={{ flexWrap: "wrap", paddingTop: "0.35rem" }}
  >
    {["Yes", "No"].map((option) => (
      <Form.Check
        key={option}
        type="radio"
        label={option}
        name={name}
        id={`${name}-${option}`}
        value={option}
        checked={value === (option === "Yes")}
        onChange={(e) => onChange(e.target.value === "Yes")}
      />
    ))}
  </div>
);
